
import { Tables } from "@/integrations/supabase/types";
import { useQuoteOperations } from "@/hooks/useQuoteOperations";
import QuoteTabsContainer from "./QuoteTabsContainer";
import QuoteDeleteDialog from "./QuoteDeleteDialog";
import EmptyQuotesState from "./EmptyQuotesState";

type Quote = Tables<'quotes'>;

interface QuotesSectionProps {
  bookingId: string;
  quotes: Quote[];
  isAdmin: boolean;
  isBookingOwner: boolean;
  onQuoteUpdate?: () => void;
}

const QuotesSection = ({
  bookingId,
  quotes,
  isAdmin,
  isBookingOwner,
  onQuoteUpdate
}: QuotesSectionProps) => {
  const {
    loadingQuoteId,
    generatingPayment,
    deletingQuoteId,
    setDeletingQuoteId,
    handleQuoteResponse,
    handleDeleteQuote
  } = useQuoteOperations(bookingId, quotes, onQuoteUpdate);

  // Filter quotes by status - be more inclusive for "active" quotes
  const activeQuotes = quotes.filter(q => q.status === 'pending' || q.status === 'accepted' || q.status === 'submitted' || q.status === null);
  const declinedQuotes = quotes.filter(q => q.status === 'rejected' || q.status === 'expired' || q.status === 'declined');

  // Determine if user can interact with quote buttons
  const canInteractWithQuotes = isBookingOwner;
  const isAdminViewingOthersBooking = isAdmin && !isBookingOwner;

  console.log('[QUOTES-SECTION] Rendering with quotes:', quotes.length, 'Active:', activeQuotes.length, 'Declined:', declinedQuotes.length);
  console.log('[QUOTES-SECTION] Quote statuses:', quotes.map(q => ({
    id: q.id.slice(-8),
    status: q.status
  })));

  if (!quotes || quotes.length === 0) {
    return <EmptyQuotesState isAdmin={isAdmin} bookingId={bookingId} onQuoteUpdate={onQuoteUpdate} />;
  }

  return (
    <div>
      <QuoteTabsContainer 
        activeQuotes={activeQuotes} 
        declinedQuotes={declinedQuotes} 
        isAdmin={isAdmin}
        canInteractWithQuotes={canInteractWithQuotes} 
        isAdminViewingOthersBooking={isAdminViewingOthersBooking} 
        loadingQuoteId={loadingQuoteId} 
        generatingPayment={generatingPayment} 
        bookingId={bookingId} 
        onQuoteResponse={handleQuoteResponse} 
        onDeleteQuote={setDeletingQuoteId} 
        onQuoteUpdate={onQuoteUpdate} 
      />

      <QuoteDeleteDialog 
        isOpen={!!deletingQuoteId} 
        onClose={() => setDeletingQuoteId(null)} 
        onConfirm={handleDeleteQuote} 
      />
    </div>
  );
};

export default QuotesSection;
